import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTower"><Path d="M14.5 22H9.5V16.5H14.5V22Z" fill="currentColor"/><Path d="M19.5 15.5H4.5L2.5 10.5H21.5L19.5 15.5Z" fill="currentColor"/><Path d="M16 4H13V5.5H19.5L18 9.5H6L4.5 5.5H11V4H8V2H16V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTower;
